import { render, staticRenderFns } from "./getAll.vue?vue&type=template&id=6e2ec0ae&"
import script from "./getAll.vue?vue&type=script&lang=js&"
export * from "./getAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports